import {
  Box,
  Stack,
  Divider,
  IconButton,
  Typography,
} from '@mui/material';
import MyChip from './MyChip';
import React, { useState,useEffect } from 'react';
import { EditIcon } from '../../../utils/Icons';
import MySkeleton from '../../../components/Skeleton';
import IcanHelpYouWithModal from './IcanHelpYouWithModal';
import AreasofExpertiseModal from './AreasofExpertiseModal';
import { useAppSelector } from '../../../redux/hooks';
import { getUserDetails } from '../../../utils/orgName';
import { API } from '../../../api';
interface Props {
  heading: string;
  editing?: boolean;
  divider?: boolean;
  loading?: boolean;
  param?: string;
  placeName?: string;
  chipType?: 'fill' | 'fill-blue' | 'outline';
  data?: string[]; // Change the type to string[]
  disableApiCall?: boolean;
}

const TextAndChipSection: React.FC<Props> = ({
  heading,
  editing = false,
  divider = false,
  loading = false,
  chipType = 'fill',
  data = [],
  param,
  placeName,
  disableApiCall = false
}) => {
  const chipData = data.length > 0 ? data : [];
  const [openPopup, setOpenPopup] = useState(false);
  const handleOpenPopup = (flag: boolean) => setOpenPopup(flag);
  const [maxObjectives, setMaxObjectives] = useState<number | undefined>();
  const [objectivesList, setObjectivesList] = useState<any[]>([]);
  const [loadingObjectives, setLoadingObjectives] = useState(false);
  const existingLearningObjectives = useAppSelector((state) => state.userProfile.data?.learningObjectives || []);
  const { orgId } = getUserDetails();
  
  const isEditDisabled = param === 'AreasofExpertise' && 
  maxObjectives !== undefined && 
  existingLearningObjectives.length >= maxObjectives &&
  objectivesList.filter((obj: any) => 
    !existingLearningObjectives.some((existing) => existing.objective === obj.objective)
  ).length === 0;

  useEffect(() => {
    if (param === 'AreasofExpertise' && !disableApiCall) {
      fetchLearningObjectives();
    }
  }, [param, disableApiCall]);

  const fetchLearningObjectives = async () => {
    if (!orgId) return;

    setLoadingObjectives(true);
    try {
      const response = await API.getUserLearningObjectives({ orgId });
      setObjectivesList(response.data.data || []);

      const objectivesData = response?.data?.data ?? [];

      if (Array.isArray(objectivesData)) {
        const calculatedMax = objectivesData.length > 0 ? objectivesData.length : 10;
        setMaxObjectives(calculatedMax);
      }
    } catch (error) {
      console.error('Failed to fetch learning objectives', error);
    } finally {
      setLoadingObjectives(false);
    }
  };

  const getChipColor = () => {
    if (chipType === 'outline') return '#68717A';
    return undefined;
  };

  const getChipBg = () => {
    if (chipType === 'outline') return '#FFFFFF';
    if (chipType === 'fill-blue') return '#0071A9';
    return undefined;
  };

  const getChipBorder = () => {
    if (chipType === 'outline') return '1px solid #CED4DA';
    if (chipType === 'fill-blue') return '1px solid #0071A9';
    return undefined;
  };

  const handleEditClick = () => {
    if (param === 'IcanHelpYouWith' || param === 'AreasofExpertise') {
      setOpenPopup(true);
    }
  };

  return (
    <>
      <Box pb={divider ? 0 : 2}>
        <Box px={divider ? 2 : 0} display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h5" pt={placeName === 'publicProfile' && param === 'IcanHelpYouWith' ? 0 : 2} pb={2}>
            {loading ? <MySkeleton variant="text" height={16} width={150} /> : heading}
          </Typography>
          {editing && (
             <IconButton 
             size="small" 
             onClick={handleEditClick}
             disabled={isEditDisabled}
             sx={{ 
               opacity: isEditDisabled ? 0.5 : 1,
               cursor: isEditDisabled ? 'not-allowed' : 'pointer'
             }}
           >
             <EditIcon />
           </IconButton>
          )}
        </Box>

        {/* Divider for profile page */}
        {divider && <Divider />}

        <Stack p={divider ? 2 : 0} direction="row" useFlexGap flexWrap="wrap" spacing={1}>
          {loading ? (
            Array.from({ length: 4 }).map((_, index) => <MyChip key={index} loading />)
          ) : chipData.length > 0 ? (
            chipData.map((topic, index) => (
              <MyChip
                key={index}
                label={topic}
                color={getChipColor()}
                border={getChipBorder()}
                backgroundColor={getChipBg()}
              />
            ))
          ) : (
            <Typography>Not added yet</Typography>
          )}
        </Stack>
      </Box>

      {/* Conditionally Render the Right Modal */}
      {param === 'IcanHelpYouWith' && (
        <IcanHelpYouWithModal openPopup={openPopup} handleOpenPopup={handleOpenPopup} />
      )}
      {param === 'AreasofExpertise' && (
        <AreasofExpertiseModal openPopup={openPopup} handleOpenPopup={handleOpenPopup} />
      )}
    </>
  );
};

export default TextAndChipSection;
